import axios from 'axios';
import Cookies from 'js-cookie'
//兼容localstorage的包
import storejs from 'storejs';
// 以服务的方式调用。引入element Loading 服务
import { Loading } from 'element-ui';
let loadingInstance;
// 引入消息提示
import { Message } from 'element-ui';
import params from "@/config/config"
import qs from 'qs'

let messageInstance;
//配置axios实例
let instanceAxios = axios.create({
  baseURL: params.VUE_APP_API_BASE,
  timeout: 100000,
});
// 请求拦截器
instanceAxios.interceptors.request.use(
  (config) => {
    // 发送请求之前
    // loading
    loadingInstance = Loading.service({
      text: '加载中...',
      background: 'rgba(0,0,0,0)'
    });
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    console.log('config---', config)

    return config
  },

  //请求错误
  (error) => {
    //loading 停止
    loadingInstance.close();
    // 弹窗 网络异常
    messageInstance = Message({
      message: '网络异常',
      type: 'warning',
    });
    return Promise.reject(error)
  },
)
let instanceAxios1 = axios.create({
  baseURL: params.VUE_APP_API_BASE,
  timeout: 10000,
});
// 请求拦截器
instanceAxios1.interceptors.request.use(
  (config) => {
    // 发送请求之前
    // loading
    loadingInstance = Loading.service({
      text: '加载中...',
      background: 'rgba(0,0,0,0)'
    });
    console.log('config---', config)
    config.headers['Content-Type'] = `multipart/form-data;charset=utf-8`
    return config
  },
  //请求错误
  (error) => {
    //loading 停止
    loadingInstance.close();
    // 弹窗 网络异常
    messageInstance = Message({
      message: '网络异常',
      type: 'warning',
    });
    return Promise.reject(error)
  },
)
// 响应拦截器
instanceAxios1.interceptors.response.use(
  (response) => {
    //响应数据
    //loading停止
    loadingInstance.close();
    return response;

  },
  (error) => {
    //loading停止
    loadingInstance.close();
    // 弹出错误
    // messageInstance = Message({
    //     message:error,
    //     type:'warning',
    // });
    return Promise.reject(error)
  },
)
// 响应拦截器
instanceAxios.interceptors.response.use(
  (response) => {
    //响应数据
    //loading停止
    loadingInstance.close();
    const res = response.data;
    if (response.status === 200) {
      return res;
    }
    else if (response.status === 302) {
      messageInstance = Message({
        message: '账号已掉线，请重新登录',
        type: 'warning',
      });
      return Promise.reject(response);
    }
  },
  (error) => {
    //loading停止
    loadingInstance.close();
    // 弹出错误
    // messageInstance = Message({
    //     message:error,
    //     type:'warning',
    // });
    return Promise.reject(error)
  },
)

//POST新增 DELETE删除 PUT更新 GET查询
const http = {
  postfile(url, params) {
    let urlParams = params
    let requestUrl = Cookies.get('QYS-JWT') ? url + "?jwt=" + Cookies.get('QYS-JWT') : url
    return instanceAxios1.post(requestUrl, urlParams).then((res) => {
      return res;
    })
  },
  post(url, params) {
    let urlParams = qs.stringify(params)
    let requestUrl = Cookies.get('QYS-JWT') ? url + "?jwt=" + Cookies.get('QYS-JWT') : url
    return instanceAxios.post(requestUrl, urlParams).then((res) => {
      return res;
    })
  },
  delete(url, params) {
    var urlParams = {
      ...params
    };
    let requestUrl = Cookies.get('QYS-JWT') ? url + "?jwt=" + Cookies.get('QYS-JWT') : url

    return instanceAxios.delete(requestUrl, { data: urlParams }).then((res) => {
      return res;
    })
  },
  put(url, params) {
    var urlParams = {
      ...params
    };
    let requestUrl = Cookies.get('QYS-JWT') ? url + "?jwt=" + Cookies.get('QYS-JWT') : url
    return instanceAxios.put(requestUrl, urlParams).then((res) => {
      return res;
    })
  },
  get(url, params) {
    var urlParams = {
      ...params
    };
    let requestUrl = Cookies.get('QYS-JWT') ? url + "?jwt=" + Cookies.get('QYS-JWT') : url
    return instanceAxios.get(requestUrl, { params: urlParams }).then((res) => {
      return res;
    })
  },
};
window.instanceAxios = instanceAxios;
export default http



// WEBPACK FOOTER //
// ./src/http/http.js